module.exports = __webpack_public_path__ + "img/AGR-B-1-I.5e059d1d.png";